import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';
import { ModalHeader, ModalContent, ModalFooter } from '@bibliocommons/modal';

import TextArea from 'app/components/shared/TextArea';
import './OffensiveContentForm.scss';

export default class OffensiveContentForm extends React.PureComponent {
  state = {
    offensiveDetails: ''
  };

  render() {
    const { handleSubmit, isLoading } = this.props;
    return (
      <div className="cp-offensive-content-form">
        <ModalHeader title={<FormattedMessage id="flag_offensive" />} />
        <ModalContent>
          <FormattedMessage id="offensive_note" />
          <TextArea
            value={this.state.offensiveDetails}
            handleChange={text => this.setState({ offensiveDetails: text })}
            id="offensive-content-reason-text-area"
            maxLength={1000}
            label={<FormattedMessage id="reason" />}
            fitToText
            minHeight="9rem"
          />
        </ModalContent>
        <ModalFooter
          primaryActionButtonText={<FormattedMessage id="button_submit" />}
          primaryActionButtonTag={TransactionalSolidButton}
          handlePrimaryAction={() => handleSubmit({ offensiveDetails: this.state.offensiveDetails })}
          isLoading={isLoading}
          disabled={this.state.offensiveDetails === ''}
        />
      </div>
    );
  }
}

OffensiveContentForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};
